export default __webpack_public_path__ + "static/media/Children.a5551951.svg";